import { render, staticRenderFns } from "./OnlineStore.vue?vue&type=template&id=ca1d7c98&scoped=true&"
import script from "./OnlineStore.vue?vue&type=script&lang=js&"
export * from "./OnlineStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1d7c98",
  null
  
)

export default component.exports